export default "/img/ET.9ec6f369d3566b84d9097ccb08eb89cb.png";